import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { ErrorBoundary } from "react-error-boundary";

import { ClipOfTheDay } from "./ClipOfTheDay";
import { ContentFeed } from "./ContentFeed";
import { SuggestedFeed } from "./SuggestedFeed";
import { HomepageWrapper } from "./styledComponents";
import { HomepageViewModel } from "./ViewModel";
import { ESupportedGames } from "../../@types";
import { GAME_TO_ICON_MAP } from "../../Components/GameSelector";
import { UserBadge } from "MVVM/Components/UserBadge";
import { AdUnit } from "../../Components/Ads";

const Homepage = () => {
  const {
    contentFeeds,
    contentFeedsLoading,
    prosFeed,
    prosFeedLoading,
    todayInCs,
    todayInCsLoading,
    allstarUser,
  } = HomepageViewModel();
  const isLoggedIn = allstarUser.loggedIn;
  const csIcon = GAME_TO_ICON_MAP[ESupportedGames.CS2];

  return (
    <HomepageWrapper>
      <HomepageContainer>
        <ClipOfTheDay />
        <AdContainer>
          <AdUnit
            slotId="homepage-billboard"
            adUnitType="billboard"
            allowProgrammatic
            collapseIfEmpty
          />
        </AdContainer>
        {isLoggedIn ? (
          <ContentFeed
            title="For You"
            data={contentFeeds?.forYou}
            loading={contentFeedsLoading}
            suggestionReason="Suggested for you"
            vanillaThumbnail
          />
        ) : prosFeed || prosFeedLoading ? (
          <ContentFeed
            title="From the Pros"
            data={prosFeed}
            loading={prosFeedLoading}
            isProsFeed={true}
            icon={
              <UserBadge
                userGroup="PRO_PLAYER"
                style={{ marginRight: "8px" }}
              />
            }
          />
        ) : (
          <ContentFeed
            title="For You"
            data={contentFeeds?.forYou?.nodes}
            loading={contentFeedsLoading}
            vanillaThumbnail
          />
        )}

        {(todayInCsLoading || Boolean(todayInCs?.length)) && (
          <ContentFeed
            title="Today in Counter-Strike"
            data={todayInCs}
            loading={todayInCsLoading}
            isProsFeed={true}
            icon={csIcon}
          />
        )}

        <ContentFeed
          title="Counter-Strike 2"
          data={contentFeeds?.cs2?.nodes}
          loading={contentFeedsLoading}
          icon={csIcon}
        />

        <ContentFeed
          title="Recent Montages"
          data={contentFeeds?.montages?.nodes}
          loading={contentFeedsLoading}
          isMontageFeed={true}
        />

        <ErrorBoundary fallback={<></>}>
          <SuggestedFeed />
        </ErrorBoundary>
      </HomepageContainer>
    </HomepageWrapper>
  );
};

const HomepageContainer = styled(Flex)`
  flex-direction: column;
  gap: 32px;
  max-width: 2480px;
  padding-bottom: 80px;
  width: 100vw;
`;

const AdContainer = styled(Flex)`
  justify-content: center;
  width: 100%;
  @media (min-width: 1500px) {
    display: none;
  }
`;

export default Homepage;
